import {ItemAtendimento} from './lista-atendimento';

export class FunilEtapa {
  id = 0;
  codigo = 0;
  nome = '';
  cor = '#2E5266';
  ordem = 0;
  ativo = true;
  atendimentos: ItemAtendimento[] = [];
  total = 0;
}
